import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  intervalUnit: '',
  essDataConsumpData: {
    dailyData: [
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-east 01',
        switch: 'bet east - 01',
        month: 'december 2021',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-east 02',
        switch: 'bet east - 02',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        isSelected: false,
        switch: 'bet-east 03',
        switch: 'bet east - 03',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },

      {
        barColor: '#FF00D5',
        switchName: 'bet-east 04',
        switch: 'bet east - 04',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-east 05',
        switch: 'bet east - 05',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-west 01',
        switch: 'bet west - 01',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-west 02',
        switch: 'bet west - 02',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-west 03',
        switch: 'bet west - 03',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'be- west 04',
        switch: 'bet west - 04',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-west 05',
        switch: 'bet west - 05',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'south-coast 01',
        switch: 'south coast - 01',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'south-cost 02',
        switch: 'south cost - 02',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'south-cost 03',
        switch: 'south cost - 03',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'south-cost 04',
        switch: 'south cost - 04',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'south-cost 05',
        switch: 'south cost - 05',
        isSelected: false,
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
    ],

    dailyKeys: [
      'december01',
      'december02',
      'december03',
      'december04',
      'december05',
      'december06',
      'december07',
      'december08',
      'december09',
      'december10',
      'december11',
      'december12',
      'december13',
      'december14',
      'december15',
      'december16',
      'december17',
      'december18',
      'december19',
      'december20',
      'december21',
      'december22',
      'december23',
      'december24',
      'december25',
      'december26',
      'december27',
      'december28',
      'december29',
      'december30',
      'december31',
    ],
  },
  tesDataConsumpData: {
    dailyKeys: [
      'december01',
      'december02',
      'december03',
      'december04',
      'december05',
      'december06',
      'december07',
      'december08',
      'december09',
      'december10',
      'december11',
      'december12',
      'december13',
      'december14',
      'december15',
      'december16',
      'december17',
      'december18',
      'december19',
      'december20',
      'december21',
      'december22',
      'december23',
      'december24',
      'december25',
      'december26',
      'december27',
      'december28',
      'december29',
      'december30',
      'december31',
    ],

    dailyData: [
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-east 01',
        switch: 'bet east - 01',
        month: 'december 2021',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-east 02',
        switch: 'bet east - 02',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-east 03',
        switch: 'bet east - 03',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-east 04',
        switch: 'bet east - 04',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-east 05',
        switch: 'bet east - 05',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-west 01',
        switch: 'bet west - 01',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-west 02',
        switch: 'bet west - 02',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-west 03',
        switch: 'bet west - 03',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-west 04',
        switch: 'bet west - 04',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'bet-west 05',
        switch: 'bet west - 05',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'south-coast 01',
        switch: 'south coast - 01',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'south-cost 02',
        switch: 'south cost - 02',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'south-cost 03',
        switch: 'south cost - 03',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'south-cost 04',
        switch: 'south cost - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF0080',
        isSelected: false,
        switchName: 'south-cost 05',
        switch: 'south cost - 05',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
    ],
  },
  tgsDataConsumpData: {
    dailyKeys: [
      'december01',
      'december02',
      'december03',
      'december04',
      'december05',
      'december06',
      'december07',
      'december08',
      'december09',
      'december10',
      'december11',
      'december12',
      'december13',
      'december14',
      'december15',
      'december16',
      'december17',
      'december18',
      'december19',
      'december20',
      'december21',
      'december22',
      'december23',
      'december24',
      'december25',
      'december26',
      'december27',
      'december28',
      'december29',
      'december30',
      'december31',
    ],

    dailyData: [
      {
        barColor: '#FF0080',
        switchName: 'bet-east 01',
        switch: 'bet east - 01',
        totalEnergyConsumption: 't. e. c. 50mb ',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-east 02',
        switch: 'bet east - 02',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-east 03',
        switch: 'bet east - 03',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-east 04',
        switch: 'bet east - 04',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-east 05',
        switch: 'bet east - 05',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-west 01',
        switch: 'bet west - 01',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-west 02',
        switch: 'bet west - 02',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-west 03',
        switch: 'bet west - 03',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-west 04',
        switch: 'bet west - 04',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'bet-west 05',
        switch: 'bet west - 05',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'south-coast 01',
        switch: 'south coast - 01',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'south-cost 02',
        switch: 'south cost - 02',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'south-cost 03',
        switch: 'south cost - 03',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'south-cost 04',
        switch: 'south cost - 04',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 3,
        december02TEC: '3 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 3,
        december03TEC: '3 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 3,
        december04TEC: '3 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 3,
        december05TEC: '3 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 3,
        december06TEC: '3 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 3,
        december07TEC: '3 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 3,
        december08TEC: '3 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 3,
        december09TEC: '3 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 3,
        december10TEC: '3 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 3,
        december11TEC: '3 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 3,
        december12TEC: '3 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 3,
        december13TEC: '3 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 3,
        december14TEC: '3 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 3,
        december15TEC: '3 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 3,
        december16TEC: '3 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 3,
        december17TEC: '3 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 3,
        december18TEC: '3 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 3,
        december19TEC: '3 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 3,
        december20TEC: '3 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 3,
        december21TEC: '3 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 3,
        december23TEC: '3 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 3,
        december24TEC: '3 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 3,
        december25TEC: '3 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 3,
        december26TEC: '3 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 3,
        december27TEC: '3 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 3,
        december28TEC: '3 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 3,
        december29TEC: '3 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 3,
        december30TEC: '3 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 3,
        december31TEC: '3 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
      {
        barColor: '#FF00D5',
        switchName: 'south-cost 05',
        switch: 'south cost - 05',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 mb',
        december01THU: '12 hrs',
        december01Color: '#FF0080',
        december02: 6,
        december02TEC: '6 mb',
        december02THU: '12 hrs',
        december02Color: '#FF00D5',
        december03: 6,
        december03TEC: '6 mb',
        december03THU: '12 hrs',
        december03Color: '#FF0080',
        december04: 6,
        december04TEC: '6 mb',
        december04THU: '12 hrs',
        december04Color: '#FF00D5',
        december05: 6,
        december05TEC: '6 mb',
        december05THU: '12 hrs',
        december05Color: '#FF0080',
        december06: 6,
        december06TEC: '6 mb',
        december06THU: '12 hrs',
        december06Color: '#FF00D5',
        december07: 6,
        december07TEC: '6 mb',
        december07THU: '12 hrs',
        december07Color: '#FF0080',
        december08: 6,
        december08TEC: '6 mb',
        december08THU: '12 hrs',
        december08Color: '#FF00D5',
        december09: 6,
        december09TEC: '6 mb',
        december09THU: '12 hrs',
        december09Color: '#FF0080',
        december10: 6,
        december10TEC: '6 mb',
        december10THU: '12 hrs',
        december10Color: '#FF00D5',
        december11: 6,
        december11TEC: '6 mb',
        december11THU: '12 hrs',
        december11Color: '#FF0080',
        december12: 6,
        december12TEC: '6 mb',
        december12THU: '12 hrs',
        december12Color: '#FF00D5',
        december13: 6,
        december13TEC: '6 mb',
        december13THU: '12 hrs',
        december13Color: '#FF0080',
        december14: 6,
        december14TEC: '6 mb',
        december14THU: '12 hrs',
        december14Color: '#FF00D5',
        december15: 6,
        december15TEC: '6 mb',
        december15THU: '12 hrs',
        december15Color: '#FF0080',
        december16: 6,
        december16TEC: '6 mb',
        december16THU: '12 hrs',
        december16Color: '#FF00D5',
        december17: 6,
        december17TEC: '6 mb',
        december17THU: '12 hrs',
        december17Color: '#FF0080',
        december18: 6,
        december18TEC: '6 mb',
        december18THU: '12 hrs',
        december18Color: '#FF00D5',
        december19: 6,
        december19TEC: '6 mb',
        december19THU: '12 hrs',
        december19Color: '#FF0080',
        december20: 6,
        december20TEC: '6 mb',
        december20THU: '12 hrs',
        december20Color: '#FF00D5',
        december21: 6,
        december21TEC: '6 mb',
        december21THU: '12 hrs',
        december21Color: '#FF0080',
        december23: 6,
        december23TEC: '6 mb',
        december23THU: '12 hrs',
        december23Color: '#FF00D5',
        december24: 6,
        december24TEC: '6 mb',
        december24THU: '12 hrs',
        december24Color: '#FF0080',
        december25: 6,
        december25TEC: '6 mb',
        december25THU: '12 hrs',
        december25Color: '#FF00D5',
        december26: 6,
        december26TEC: '6 mb',
        december26THU: '12 hrs',
        december26Color: '#FF0080',
        december27: 6,
        december27TEC: '6 mb',
        december27THU: '12 hrs',
        december27Color: '#FF00D5',
        december28: 6,
        december28TEC: '6 mb',
        december28THU: '12 hrs',
        december28Color: '#FF0080',
        december29: 6,
        december29TEC: '6 mb',
        december29THU: '12 hrs',
        december29Color: '#FF00D5',
        december30: 6,
        december30TEC: '6 mb',
        december30THU: '12 hrs',
        december30Color: '#FF0080',
        december31: 6,
        december31TEC: '6 mb',
        december31THU: '12 hrs',
        december31Color: '#FF00D5',
      },
    ],
  },

  essSwitchData: {
    monthlyData: [
      {
        switch: 'bet east - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 50,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 0,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 0,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 0,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 0,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 0,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 0,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 0,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 0,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 0,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 02',
        totalEnergyConsumption: 't. e. c. 450 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 02',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 02',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
    ],
    monthlyKeys: [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ],

    dailyData: [
      {
        switch: 'bet east - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 01',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 02',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 03',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 04',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 05',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south coast - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
    ],

    dailyKeys: [
      'december01',
      'december02',
      'december03',
      'december04',
      'december05',
      'december06',
      'december07',
      'december08',
      'december09',
      'december10',
      'december11',
      'december12',
      'december13',
      'december14',
      'december15',
      'december16',
      'december17',
      'december18',
      'december19',
      'december20',
      'december21',
      'december22',
      'december23',
      'december24',
      'december25',
      'december26',
      'december27',
      'december28',
      'december29',
      'december30',
      'december31',
    ],
  },
  tesSwitchData: {
    monthlyData: [
      {
        switch: 'bet east - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 50,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 0,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 0,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 0,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 0,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 0,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 0,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 0,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 0,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 0,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'bet east - 02',
        totalEnergyConsumption: 't. e. c. 450 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'bet east - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'bet east - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'bet east - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'bet west - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'bet west - 02',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'bet west - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'bet west - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'bet west - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'south coast - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'south coast - 02',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'south coast - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'south coast - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
      {
        switch: 'south coast - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#95FF45',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#D5FF45',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#95FF45',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#D5FF45',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#95FF45',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#D5FF45',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#95FF45',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#D5FF45',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#95FF45',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#D5FF45',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#95FF45',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#D5FF45',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#95FF45',
      },
    ],
    monthlyKeys: [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ],

    dailyData: [
      {
        switch: 'bet east - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'bet east - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'bet east - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'bet east - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'bet east - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'bet west - 01',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'bet west - 02',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'bet west - 03',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'bet west - 04',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'bet west - 05',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'south coast - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'south cost - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'south cost - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'south cost - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
      {
        switch: 'south cost - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#95FF45',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#D5FF45',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#95FF45',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#D5FF45',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#95FF45',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#D5FF45',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#95FF45',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#D5FF45',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#95FF45',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#D5FF45',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#95FF45',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#D5FF45',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#95FF45',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#D5FF45',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#95FF45',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#D5FF45',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#95FF45',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#D5FF45',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#95FF45',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#D5FF45',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#95FF45',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#D5FF45',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#95FF45',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#D5FF45',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#95FF45',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#D5FF45',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#95FF45',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#D5FF45',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#95FF45',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#D5FF45',
      },
    ],

    dailyKeys: [
      'december01',
      'december02',
      'december03',
      'december04',
      'december05',
      'december06',
      'december07',
      'december08',
      'december09',
      'december10',
      'december11',
      'december12',
      'december13',
      'december14',
      'december15',
      'december16',
      'december17',
      'december18',
      'december19',
      'december20',
      'december21',
      'december22',
      'december23',
      'december24',
      'december25',
      'december26',
      'december27',
      'december28',
      'december29',
      'december30',
      'december31',
    ],
  },
  tgsSwitchData: {
    monthlyData: [
      {
        switch: 'bet east - 01',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FF7800',
        january: 50,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 0,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 0,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 0,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 0,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 0,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 0,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 0,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 0,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 0,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'bet east - 02',
        totalEnergyConsumption: 't. e. c. 450 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'bet east - 03',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'bet east - 04',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'bet east - 05',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'bet west - 01',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'bet west - 02',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'bet west - 04',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'bet west - 05',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'south coast - 01',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'south coast - 02',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'south coast - 03',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'south coast - 04',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
      {
        switch: 'south coast - 05',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#FFC400',
        barColor: '#FFC400',
        january: 32,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#FFC400',
        february: 35,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#FF7800',
        march: 24,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#FFC400',
        april: 12,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#FF7800',
        may: 7,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#FFC400',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#FF7800',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#FFC400',
        august: 5,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#FF7800',
        september: 10,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#FFC400',
        october: 15,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#FF7800',
        november: 15,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#FFC400',
        december: 35,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#FF7800',
      },
    ],
    monthlyKeys: [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ],

    dailyData: [
      {
        switch: 'bet east - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'bet east - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'bet east - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'bet east - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'bet east - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'bet west - 01',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'bet west - 02',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'bet west - 03',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'bet west - 04',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'bet west - 05',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'south coast - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'south cost - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'south cost - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'south cost - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
      {
        switch: 'south cost - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#FFC400',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#FF7800',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#FFC400',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#FF7800',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#FFC400',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#FF7800',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#FFC400',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#FF7800',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#FFC400',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#FF7800',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#FFC400',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#FF7800',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#FFC400',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#FF7800',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#FFC400',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#FF7800',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#FFC400',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#FF7800',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#FFC400',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#FF7800',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#FFC400',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#FF7800',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#FFC400',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#FF7800',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#FFC400',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#FF7800',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#FFC400',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#FF7800',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#FFC400',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#FF7800',
      },
    ],

    dailyKeys: [
      'december01',
      'december02',
      'december03',
      'december04',
      'december05',
      'december06',
      'december07',
      'december08',
      'december09',
      'december10',
      'december11',
      'december12',
      'december13',
      'december14',
      'december15',
      'december16',
      'december17',
      'december18',
      'december19',
      'december20',
      'december21',
      'december22',
      'december23',
      'december24',
      'december25',
      'december26',
      'december27',
      'december28',
      'december29',
      'december30',
      'december31',
    ],
  },
  doublesSidedChartData: {
    firstYearMonthlyData: [
      {
        switch: 'bet east - 01',
        totalEnergyConsumption: 't. e. c. 50kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 50,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 0,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 0,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 0,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 0,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 0,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 0,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 0,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 0,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 0,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 02',
        totalEnergyConsumption: 't. e. c. 450 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 02',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 02',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
    ],
    firstYearMonthlyKeys: [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ],
    secondYearMonthlyData: [
      {
        switch: 'bet east - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 50,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 0,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 0,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 0,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 0,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 0,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 0,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 0,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 0,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 0,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 02',
        totalEnergyConsumption: 't. e. c. 450 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 02',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 02',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
    ],
    secondYearMonthlyKeys: [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ],
    firstYearDailyData: [
      {
        switch: 'bet east - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 01',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 02',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 03',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 04',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 05',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south coast - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
    ],
    firstYearDailyKeys: [
      'december01',
      'december02',
      'december03',
      'december04',
      'december05',
      'december06',
      'december07',
      'december08',
      'december09',
      'december10',
      'december11',
      'december12',
      'december13',
      'december14',
      'december15',
      'december16',
      'december17',
      'december18',
      'december19',
      'december20',
      'december21',
      'december22',
      'december23',
      'december24',
      'december25',
      'december26',
      'december27',
      'december28',
      'december29',
      'december30',
      'december31',
    ],
    secondYearDailyData: [
      {
        switch: 'bet east - 01',
        month: 'december 2022',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 02',
        month: 'december 2022',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 03',
        month: 'december 2022',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 04',
        month: 'december 2022',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 05',
        month: 'december 2022',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 01',
        month: 'december 2022',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 02',
        month: 'december 2022',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 03',
        month: 'december 2022',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 04',
        month: 'december 2022',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 05',
        month: 'december 2022',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south coast - 01',
        month: 'december 2022',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 02',
        month: 'december 2022',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 03',
        month: 'december 2022',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 04',
        month: 'december 2022',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 05',
        month: 'december 2022',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
    ],
    secondYearDailyKeys: [
      'december01',
      'december02',
      'december03',
      'december04',
      'december05',
      'december06',
      'december07',
      'december08',
      'december09',
      'december10',
      'december11',
      'december12',
      'december13',
      'december14',
      'december15',
      'december16',
      'december17',
      'december18',
      'december19',
      'december20',
      'december21',
      'december22',
      'december23',
      'december24',
      'december25',
      'december26',
      'december27',
      'december28',
      'december29',
      'december30',
      'december31',
    ],
  },
  hpElectricData: {
    monthlyData: [
      {
        switch: 'bet east - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 50,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 0,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 0,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 0,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 0,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 0,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 0,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 0,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 0,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 0,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 02',
        totalEnergyConsumption: 't. e. c. 450 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet east - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 02',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'bet west - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 01',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 02',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 03',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 04',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'south coast - 05',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 kw',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 kw',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 kw',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 kw',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 kw',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 kw',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 kw',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 kw',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 kw',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 kw',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 kw',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 kw',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
    ],
    monthlyKeys: [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ],

    dailyData: [
      {
        switch: 'bet east - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 01',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 02',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 03',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 04',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 05',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south coast - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 kw',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 kw',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 kw',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 kw',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 kw',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 kw',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 kw',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 kw',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 kw',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 kw',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 kw',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 kw',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 kw',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 kw',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 kw',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 kw',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 kw',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 kw',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 kw',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 kw',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 kw',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 kw',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 kw',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 kw',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 kw',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 kw',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 kw',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 kw',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 kw',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 kw',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
    ],

    dailyKeys: [
      'december01',
      'december02',
      'december03',
      'december04',
      'december05',
      'december06',
      'december07',
      'december08',
      'december09',
      'december10',
      'december11',
      'december12',
      'december13',
      'december14',
      'december15',
      'december16',
      'december17',
      'december18',
      'december19',
      'december20',
      'december21',
      'december22',
      'december23',
      'december24',
      'december25',
      'december26',
      'december27',
      'december28',
      'december29',
      'december30',
      'december31',
    ],
  },
  hpGasData: {
    monthlyData: [
      {
        switch: 'ny east - 01',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 50,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 0,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 0,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 0,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 0,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 0,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 0,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 0,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 0,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 0,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'ny east - 02',
        totalEnergyConsumption: 't. e. c. 450 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'ny east - 03',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },

      {
        switch: 'ny west - 01',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'ny west - 02',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'ny west - 03',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
      {
        switch: 'ny west - 04',
        totalEnergyConsumption: 't. e. c. 50 m³',
        totalUsageHours: 't. h. u. 500 hrs',
        barColor: '#83FFFF',
        january: 45,
        januaryTEC: '50 m³',
        januaryTHU: '20 hours',
        januaryColor: '#70C7F0',
        february: 65,
        februaryTEC: '50 m³',
        februaryTHU: '20 hours',
        februaryColor: '#83FFFF',
        march: 35,
        marchTEC: '50 m³',
        marchTHU: '20 hours',
        marchColor: '#70C7F0',
        april: 30,
        aprilTEC: '50 m³',
        aprilTHU: '20 hours',
        aprilColor: '#83FFFF',
        may: 25,
        mayTEC: '50 m³',
        mayTHU: '20 hours',
        mayColor: '#70C7F0',
        june: 10,
        juneTEC: '50 m³',
        juneTHU: '20 hours',
        juneColor: '#83FFFF',
        july: 0,
        julyTEC: '50 m³',
        julyTHU: '20 hours',
        julyColor: '#70C7F0',
        august: 0,
        augustTEC: '50 m³',
        augustTHU: '20 hours',
        augustColor: '#83FFFF',
        september: 12,
        septemberTEC: '50 m³',
        septemberTHU: '20 hours',
        septemberColor: '#70C7F0',
        october: 25,
        octoberTEC: '50 m³',
        octoberTHU: '20 hours',
        octoberColor: '#83FFFF',
        november: 35,
        novemberTEC: '50 m³',
        novemberTHU: '20 hours',
        novemberColor: '#70C7F0',
        december: 50,
        decemberTEC: '50 m³',
        decemberTHU: '20 hours',
        decemberColor: '#83FFFF',
      },
    ],
    monthlyKeys: [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ],

    dailyData: [
      {
        switch: 'bet east - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet east - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 01',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 02',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 03',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 04',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'bet west - 05',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south coast - 01',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 02',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 03',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 04',
        month: 'december 2021',
        december01: 3,
        december01TEC: '3 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 3,
        december02TEC: '3 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 3,
        december03TEC: '3 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 3,
        december04TEC: '3 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 3,
        december05TEC: '3 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 3,
        december06TEC: '3 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 3,
        december07TEC: '3 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 3,
        december08TEC: '3 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 3,
        december09TEC: '3 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 3,
        december10TEC: '3 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 3,
        december11TEC: '3 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 3,
        december12TEC: '3 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 3,
        december13TEC: '3 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 3,
        december14TEC: '3 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 3,
        december15TEC: '3 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 3,
        december16TEC: '3 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 3,
        december17TEC: '3 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 3,
        december18TEC: '3 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 3,
        december19TEC: '3 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 3,
        december20TEC: '3 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 3,
        december21TEC: '3 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 3,
        december23TEC: '3 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 3,
        december24TEC: '3 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 3,
        december25TEC: '3 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 3,
        december26TEC: '3 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 3,
        december27TEC: '3 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 3,
        december28TEC: '3 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 3,
        december29TEC: '3 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 3,
        december30TEC: '3 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 3,
        december31TEC: '3 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
      {
        switch: 'south cost - 05',
        month: 'december 2021',
        december01: 6,
        december01TEC: '6 m³',
        december01THU: '12 hrs',
        december01Color: '#83FFFF',
        december02: 6,
        december02TEC: '6 m³',
        december02THU: '12 hrs',
        december02Color: '#70C7F0',
        december03: 6,
        december03TEC: '6 m³',
        december03THU: '12 hrs',
        december03Color: '#83FFFF',
        december04: 6,
        december04TEC: '6 m³',
        december04THU: '12 hrs',
        december04Color: '#70C7F0',
        december05: 6,
        december05TEC: '6 m³',
        december05THU: '12 hrs',
        december05Color: '#83FFFF',
        december06: 6,
        december06TEC: '6 m³',
        december06THU: '12 hrs',
        december06Color: '#70C7F0',
        december07: 6,
        december07TEC: '6 m³',
        december07THU: '12 hrs',
        december07Color: '#83FFFF',
        december08: 6,
        december08TEC: '6 m³',
        december08THU: '12 hrs',
        december08Color: '#70C7F0',
        december09: 6,
        december09TEC: '6 m³',
        december09THU: '12 hrs',
        december09Color: '#83FFFF',
        december10: 6,
        december10TEC: '6 m³',
        december10THU: '12 hrs',
        december10Color: '#70C7F0',
        december11: 6,
        december11TEC: '6 m³',
        december11THU: '12 hrs',
        december11Color: '#83FFFF',
        december12: 6,
        december12TEC: '6 m³',
        december12THU: '12 hrs',
        december12Color: '#70C7F0',
        december13: 6,
        december13TEC: '6 m³',
        december13THU: '12 hrs',
        december13Color: '#83FFFF',
        december14: 6,
        december14TEC: '6 m³',
        december14THU: '12 hrs',
        december14Color: '#70C7F0',
        december15: 6,
        december15TEC: '6 m³',
        december15THU: '12 hrs',
        december15Color: '#83FFFF',
        december16: 6,
        december16TEC: '6 m³',
        december16THU: '12 hrs',
        december16Color: '#70C7F0',
        december17: 6,
        december17TEC: '6 m³',
        december17THU: '12 hrs',
        december17Color: '#83FFFF',
        december18: 6,
        december18TEC: '6 m³',
        december18THU: '12 hrs',
        december18Color: '#70C7F0',
        december19: 6,
        december19TEC: '6 m³',
        december19THU: '12 hrs',
        december19Color: '#83FFFF',
        december20: 6,
        december20TEC: '6 m³',
        december20THU: '12 hrs',
        december20Color: '#70C7F0',
        december21: 6,
        december21TEC: '6 m³',
        december21THU: '12 hrs',
        december21Color: '#83FFFF',
        december23: 6,
        december23TEC: '6 m³',
        december23THU: '12 hrs',
        december23Color: '#70C7F0',
        december24: 6,
        december24TEC: '6 m³',
        december24THU: '12 hrs',
        december24Color: '#83FFFF',
        december25: 6,
        december25TEC: '6 m³',
        december25THU: '12 hrs',
        december25Color: '#70C7F0',
        december26: 6,
        december26TEC: '6 m³',
        december26THU: '12 hrs',
        december26Color: '#83FFFF',
        december27: 6,
        december27TEC: '6 m³',
        december27THU: '12 hrs',
        december27Color: '#70C7F0',
        december28: 6,
        december28TEC: '6 m³',
        december28THU: '12 hrs',
        december28Color: '#83FFFF',
        december29: 6,
        december29TEC: '6 m³',
        december29THU: '12 hrs',
        december29Color: '#70C7F0',
        december30: 6,
        december30TEC: '6 m³',
        december30THU: '12 hrs',
        december30Color: '#83FFFF',
        december31: 6,
        december31TEC: '6 m³',
        december31THU: '12 hrs',
        december31Color: '#70C7F0',
      },
    ],

    dailyKeys: [
      'december01',
      'december02',
      'december03',
      'december04',
      'december05',
      'december06',
      'december07',
      'december08',
      'december09',
      'december10',
      'december11',
      'december12',
      'december13',
      'december14',
      'december15',
      'december16',
      'december17',
      'december18',
      'december19',
      'december20',
      'december21',
      'december22',
      'december23',
      'december24',
      'december25',
      'december26',
      'december27',
      'december28',
      'december29',
      'december30',
      'december31',
    ],
  },
  hpDataConsumpData: {
    dailyData: [
      {
        barColor: '#FF0080',
        switch: 'ny east - 01',
        month: 'december 2021',
        totalEnergyConsumption: 't. e. c. 50 kw',
        totalUsageHours: 't. h. u. 500 hrs',
        december01: 6,
        december01Color: '#FF0080',
        december02: 6,
        december02Color: '#70C7F0',
        december03: 6,
        december03Color: '#FF0080',
        december04: 6,
        december04Color: '#70C7F0',
        december05: 6,
        december05Color: '#FF0080',
        december06: 6,
        december06Color: '#70C7F0',
        december07: 6,
        december07Color: '#FF0080',
        december08: 6,
        december08Color: '#70C7F0',
        december09: 6,
        december09Color: '#FF0080',
        december10: 6,
        december10Color: '#70C7F0',
        december11: 6,
        december11Color: '#FF0080',
        december12: 6,
        december12Color: '#70C7F0',
        december13: 6,
        december13Color: '#FF0080',
        december14: 6,
        december14Color: '#70C7F0',
        december15: 6,
        december15Color: '#FF0080',
        december16: 6,
        december16Color: '#70C7F0',
        december17: 6,
        december17Color: '#FF0080',
        december18: 6,
        december18Color: '#70C7F0',
        december19: 6,
        december19Color: '#FF0080',
        december20: 6,
        december20Color: '#70C7F0',
        december21: 6,
        december21Color: '#FF0080',
        december23: 6,
        december23Color: '#70C7F0',
        december24: 6,
        december24Color: '#FF0080',
        december25: 6,
        december25Color: '#70C7F0',
        december26: 6,
        december26Color: '#FF0080',
        december27: 6,
        december27Color: '#70C7F0',
        december28: 6,
        december28Color: '#FF0080',
        december29: 6,
        december29Color: '#70C7F0',
        december30: 6,
        december30Color: '#FF0080',
        december31: 6,
        december31Color: '#70C7F0',
        isSelected: false,
      },
      {
        barColor: '#FF0080',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        switch: 'ny east - 02',
        month: 'december 2021',
        december01: 3,
        december01Color: '#FF0080',
        december02: 3,
        december02Color: '#70C7F0',
        december03: 3,
        december03Color: '#FF0080',
        december04: 3,
        december04Color: '#70C7F0',
        december05: 3,
        december05Color: '#FF0080',
        december06: 3,
        december06Color: '#70C7F0',
        december07: 3,
        december07Color: '#FF0080',
        december08: 3,
        december08Color: '#70C7F0',
        december09: 3,
        december09Color: '#FF0080',
        december10: 3,
        december10Color: '#70C7F0',
        december11: 3,
        december11Color: '#FF0080',
        december12: 3,
        december12Color: '#70C7F0',
        december13: 3,
        december13Color: '#FF0080',
        december14: 3,
        december14Color: '#70C7F0',
        december15: 3,
        december15Color: '#FF0080',
        december16: 3,
        december16Color: '#70C7F0',
        december17: 3,
        december17Color: '#FF0080',
        december18: 3,
        december18Color: '#70C7F0',
        december19: 3,
        december19Color: '#FF0080',
        december20: 3,
        december20Color: '#70C7F0',
        december21: 3,
        december21Color: '#FF0080',
        december23: 3,
        december23Color: '#70C7F0',
        december24: 3,
        december24Color: '#FF0080',
        december25: 3,
        december25Color: '#70C7F0',
        december26: 3,
        december26Color: '#FF0080',
        december27: 3,
        december27Color: '#70C7F0',
        december28: 3,
        december28Color: '#FF0080',
        december29: 3,
        december29Color: '#70C7F0',
        december30: 3,
        december30Color: '#FF0080',
        december31: 3,
        december31Color: '#70C7F0',
      },
      {
        barColor: '#FF0080',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        switch: 'ny east - 03',
        month: 'december 2021',
        december01: 6,
        december01Color: '#FF0080',
        december02: 6,
        december02Color: '#70C7F0',
        december03: 6,
        december03Color: '#FF0080',
        december04: 6,
        december04Color: '#70C7F0',
        december05: 6,
        december05Color: '#FF0080',
        december06: 6,
        december06Color: '#70C7F0',
        december07: 6,
        december07Color: '#FF0080',
        december08: 6,
        december08Color: '#70C7F0',
        december09: 6,
        december09Color: '#FF0080',
        december10: 6,
        december10Color: '#70C7F0',
        december11: 6,
        december11Color: '#FF0080',
        december12: 6,
        december12Color: '#70C7F0',
        december13: 6,
        december13Color: '#FF0080',
        december14: 6,
        december14Color: '#70C7F0',
        december15: 6,
        december15Color: '#FF0080',
        december16: 6,
        december16Color: '#70C7F0',
        december17: 6,
        december17Color: '#FF0080',
        december18: 6,
        december18Color: '#70C7F0',
        december19: 6,
        december19Color: '#FF0080',
        december20: 6,
        december20Color: '#70C7F0',
        december21: 6,
        december21Color: '#FF0080',
        december23: 6,
        december23Color: '#70C7F0',
        december24: 6,
        december24Color: '#FF0080',
        december25: 6,
        december25Color: '#70C7F0',
        december26: 6,
        december26Color: '#FF0080',
        december27: 6,
        december27Color: '#70C7F0',
        december28: 6,
        december28Color: '#FF0080',
        december29: 6,
        december29Color: '#70C7F0',
        december30: 6,
        december30Color: '#FF0080',
        december31: 6,
        december31Color: '#70C7F0',
      },

      {
        barColor: '#FF0080',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        switch: 'ny west - 01',
        month: 'december 2021',
        december01: 3,
        december01Color: '#FF0080',
        december02: 3,
        december02Color: '#70C7F0',
        december03: 3,
        december03Color: '#FF0080',
        december04: 3,
        december04Color: '#70C7F0',
        december05: 3,
        december05Color: '#FF0080',
        december06: 3,
        december06Color: '#70C7F0',
        december07: 3,
        december07Color: '#FF0080',
        december08: 3,
        december08Color: '#70C7F0',
        december09: 3,
        december09Color: '#FF0080',
        december10: 3,
        december10Color: '#70C7F0',
        december11: 3,
        december11Color: '#FF0080',
        december12: 3,
        december12Color: '#70C7F0',
        december13: 3,
        december13Color: '#FF0080',
        december14: 3,
        december14Color: '#70C7F0',
        december15: 3,
        december15Color: '#FF0080',
        december16: 3,
        december16Color: '#70C7F0',
        december17: 3,
        december17Color: '#FF0080',
        december18: 3,
        december18Color: '#70C7F0',
        december19: 3,
        december19Color: '#FF0080',
        december20: 3,
        december20Color: '#70C7F0',
        december21: 3,
        december21Color: '#FF0080',
        december23: 3,
        december23Color: '#70C7F0',
        december24: 3,
        december24Color: '#FF0080',
        december25: 3,
        december25Color: '#70C7F0',
        december26: 3,
        december26Color: '#FF0080',
        december27: 3,
        december27Color: '#70C7F0',
        december28: 3,
        december28Color: '#FF0080',
        december29: 3,
        december29Color: '#70C7F0',
        december30: 3,
        december30Color: '#FF0080',
        december31: 3,
        december31Color: '#70C7F0',
      },
      {
        barColor: '#FF0080',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        switch: 'ny west - 02',
        month: 'december 2021',
        december01: 6,
        december01Color: '#FF0080',
        december02: 6,
        december02Color: '#70C7F0',
        december03: 6,
        december03Color: '#FF0080',
        december04: 6,
        december04Color: '#70C7F0',
        december05: 6,
        december05Color: '#FF0080',
        december06: 6,
        december06Color: '#70C7F0',
        december07: 6,
        december07Color: '#FF0080',
        december08: 6,
        december08Color: '#70C7F0',
        december09: 6,
        december09Color: '#FF0080',
        december10: 6,
        december10Color: '#70C7F0',
        december11: 6,
        december11Color: '#FF0080',
        december12: 6,
        december12Color: '#70C7F0',
        december13: 6,
        december13Color: '#FF0080',
        december14: 6,
        december14Color: '#70C7F0',
        december15: 6,
        december15Color: '#FF0080',
        december16: 6,
        december16Color: '#70C7F0',
        december17: 6,
        december17Color: '#FF0080',
        december18: 6,
        december18Color: '#70C7F0',
        december19: 6,
        december19Color: '#FF0080',
        december20: 6,
        december20Color: '#70C7F0',
        december21: 6,
        december21Color: '#FF0080',
        december23: 6,
        december23Color: '#70C7F0',
        december24: 6,
        december24Color: '#FF0080',
        december25: 6,
        december25Color: '#70C7F0',
        december26: 6,
        december26Color: '#FF0080',
        december27: 6,
        december27Color: '#70C7F0',
        december28: 6,
        december28Color: '#FF0080',
        december29: 6,
        december29Color: '#70C7F0',
        december30: 6,
        december30Color: '#FF0080',
        december31: 6,
        december31Color: '#70C7F0',
      },
      {
        barColor: '#FF0080',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        switch: 'ny west - 03',
        month: 'december 2021',
        december01: 3,
        december01Color: '#FF0080',
        december02: 3,
        december02Color: '#70C7F0',
        december03: 3,
        december03Color: '#FF0080',
        december04: 3,
        december04Color: '#70C7F0',
        december05: 3,
        december05Color: '#FF0080',
        december06: 3,
        december06Color: '#70C7F0',
        december07: 3,
        december07Color: '#FF0080',
        december08: 3,
        december08Color: '#70C7F0',
        december09: 3,
        december09Color: '#FF0080',
        december10: 3,
        december10Color: '#70C7F0',
        december11: 3,
        december11Color: '#FF0080',
        december12: 3,
        december12Color: '#70C7F0',
        december13: 3,
        december13Color: '#FF0080',
        december14: 3,
        december14Color: '#70C7F0',
        december15: 3,
        december15Color: '#FF0080',
        december16: 3,
        december16Color: '#70C7F0',
        december17: 3,
        december17Color: '#FF0080',
        december18: 3,
        december18Color: '#70C7F0',
        december19: 3,
        december19Color: '#FF0080',
        december20: 3,
        december20Color: '#70C7F0',
        december21: 3,
        december21Color: '#FF0080',
        december23: 3,
        december23Color: '#70C7F0',
        december24: 3,
        december24Color: '#FF0080',
        december25: 3,
        december25Color: '#70C7F0',
        december26: 3,
        december26Color: '#FF0080',
        december27: 3,
        december27Color: '#70C7F0',
        december28: 3,
        december28Color: '#FF0080',
        december29: 3,
        december29Color: '#70C7F0',
        december30: 3,
        december30Color: '#FF0080',
        december31: 3,
        december31Color: '#70C7F0',
      },
      {
        barColor: '#FF0080',
        totalEnergyConsumption: 't. e. c. 50 mb',
        totalUsageHours: 't. h. u. 500 hrs',
        isSelected: false,
        switch: 'ny west - 04',
        month: 'december 2021',
        december01: 6,
        december01Color: '#FF0080',
        december02: 6,
        december02Color: '#70C7F0',
        december03: 6,
        december03Color: '#FF0080',
        december04: 6,
        december04Color: '#70C7F0',
        december05: 6,
        december05Color: '#FF0080',
        december06: 6,
        december06Color: '#70C7F0',
        december07: 6,
        december07Color: '#FF0080',
        december08: 6,
        december08Color: '#70C7F0',
        december09: 6,
        december09Color: '#FF0080',
        december10: 6,
        december10Color: '#70C7F0',
        december11: 6,
        december11Color: '#FF0080',
        december12: 6,
        december12Color: '#70C7F0',
        december13: 6,
        december13Color: '#FF0080',
        december14: 6,
        december14Color: '#70C7F0',
        december15: 6,
        december15Color: '#FF0080',
        december16: 6,
        december16Color: '#70C7F0',
        december17: 6,
        december17Color: '#FF0080',
        december18: 6,
        december18Color: '#70C7F0',
        december19: 6,
        december19Color: '#FF0080',
        december20: 6,
        december20Color: '#70C7F0',
        december21: 6,
        december21Color: '#FF0080',
        december23: 6,
        december23Color: '#70C7F0',
        december24: 6,
        december24Color: '#FF0080',
        december25: 6,
        december25Color: '#70C7F0',
        december26: 6,
        december26Color: '#FF0080',
        december27: 6,
        december27Color: '#70C7F0',
        december28: 6,
        december28Color: '#FF0080',
        december29: 6,
        december29Color: '#70C7F0',
        december30: 6,
        december30Color: '#FF0080',
        december31: 6,
        december31Color: '#70C7F0',
      },
    ],

    dailyKeys: [
      'december01',
      'december02',
      'december03',
      'december04',
      'december05',
      'december06',
      'december07',
      'december08',
      'december09',
      'december10',
      'december11',
      'december12',
      'december13',
      'december14',
      'december15',
      'december16',
      'december17',
      'december18',
      'december19',
      'december20',
      'december21',
      'december22',
      'december23',
      'december24',
      'december25',
      'december26',
      'december27',
      'december28',
      'december29',
      'december30',
      'december31',
    ],
  },
};

const telemetryChartDataSlice = createSlice({
  name: 'telemetryChartData',
  initialState,
  reducers: {
    setTelemetryChartData: (state, action) => {
      Object.keys(action.payload.data).forEach((objectKey) => {
        state[action.payload.swtName][objectKey] =
          action.payload.data[objectKey];
      });
    },
    setTelemetryIntervalUnit: (state, action) => {
      state.intervalUnit = action.payload;
    },
  },
});

export default telemetryChartDataSlice;
export const selectTelemetryChartData = (state) => state.telemetryChartData;
export const { setTelemetryChartData, setTelemetryIntervalUnit } =
  telemetryChartDataSlice.actions;
